import styled from 'styled-components';

import { Div, Span } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import { Spin } from 'opencare-crown';

export const Centered = styled(Div)`
  text-align: center;
`;

export const StyledSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: ${(props) => props.color};
  }
`;

export const Highlight = styled(Span)`
  font-weight: bold;
  color: ${colors.sage6};
`;
